module.exports = __webpack_public_path__ + "static/media/BluePaste.09de4296.svg";